export enum StorageKey {
    BearerToken = 'BearerToken',
}
